import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=98f47bba&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98f47bba')) {
      api.createRecord('98f47bba', component.options)
    } else {
      api.reload('98f47bba', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=98f47bba&", function () {
      api.rerender('98f47bba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25xTK9ImJYlbc/JS/comp/IncreaseNumber.vue"
export default component.exports